<template>
  <div ref="verificationStatusModal" id="imageVerificationModal" class="modal modal-v modal-v--mobile-fullscreen fade show" tabindex="-1" role="dialog" aria-labelledby="imageVerificationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <mobile-menu
          :title="null"
          :profile="$route.meta.profile"
          :search="false"
          :modal="true"
          :bottom="true"
        ></mobile-menu>

        <button type="button" class="close " data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <form method="post" @submit.prevent="submit" enctype="multipart/form-data">
          <div class="modal-body  d-flex flex-column align-items-center justify-content-start">
            <h2 class="title title--medium mb-5">{{ trans.get('profile:edit.image_verification_modal.header') }}</h2>
            <div class="row justify-content-center align-items-center">
              <div class="col text-center">
                <img
                  class="imageVerification__image modal-gest mb-3"
                  :src="verification.verification_image ? verification.verification_image : ''"
                  alt="profile-gest"
                >
              </div>
              <div class="mx-auto">
                <img
                  class="imageVerification__image modal-gest1 mb-3"
                  :src="imageBase ? imageBase : ''"
                  alt=""
                >
              </div>
            </div>
            <div v-if="responseErrors.length" class="form-group ">
              <span v-for="responseError in responseErrors" class="invalid-feedback d-block" role="alert"><strong>{{ responseError }}</strong></span>
            </div>
            <div class="small font-weight-light text-center align-items-center" style="max-width: 400px;">
              {{ trans.get('profile:edit.image_verification_modal.info_text') }}
            </div>
            <div class="form-group choose-file__button mt-4 text-center">
              <input ref="file" type="file" accept="image/*" id="verification-image-input" name="image" v-on:change="handleFileUpload()">

              <label for="verification-image-input" class="custom-file__input mb-2">
                <i class="fa fa-camera pr-3" aria-hidden="true"></i>
                {{ trans.get('profile:edit.image_verification_modal.upload_image_label') }}
              </label>
            </div>
            <button type="submit" :disabled="uploading" class="button button__fill mx-auto mt-3 mb-3">{{ trans.get('profile:edit.image_verification_modal.verify_button') }}</button>
            <button type="button" class="button button__link mx-auto mb-3" data-dismiss="modal">{{ trans.get('profile:edit.image_verification_modal.close_button') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationStatusModal',
  props: {},
  data() {
    return {
      show: false,
      file: null,
      imageBase: null,
      uploading: false,
      verification: {
        id: null,
        status: null,
        uploaded_image: null,
        verification_image: null,
      },
      responseErrors: [],
    };
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        this.file = null;
        this.imageBase = null;
        this.load();
        $(this.$refs.verificationStatusModal).modal('show');
      } else {
        $(this.$refs.verificationStatusModal).modal('hide');
      }
    },
  },
  methods: {
    handleFileUpload() {
      this.readURL(this.$refs.file);
      this.file = this.$refs.file.files[0];
    },
    readURL(input) {
      let vm = this;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
          vm.imageBase = e.target.result;
        };
        reader.readAsDataURL(input.files[0]); // convert to base64 string
      }
    },
    submit() {
      this.responseErrors = [];
      let formData = new FormData();
      formData.append('image', this.file);

      this.uploading = true;
      axios
        .post(zRoute('ajax.user.verification.create', this.verification.id), formData)
        .then(() => {
          this.show = false;
          this.uploading = false;
          this.$store.dispatch('user/load');
        })
        .catch((error) => {
          this.uploading = false;
          const data = error.response.data;
          if (data.errors && data.errors.image) {
            this.responseErrors = data.errors.image;
          }

          if (error.response.status === 500) {
            this.responseErrors = [data.message];
          }
        });
    },
    load() {
      axios
        .get(zRoute('ajax.user.verification.show'))
        .then(response => {
          this.verification = response.data.data;
        });
    }
  },
  mounted() {
    let vm = this;
    $(this.$refs.verificationStatusModal).on('hidden.bs.modal', function () {
      vm.show = false;
    });

    this.$eventHub.$on('VerificationStatusOpen', () => {
      vm.show = true;
    });
  },
};
</script>

<style scoped>

</style>
